import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableComponentModule } from '@shared';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SidebarModule } from 'primeng/sidebar';
import { DriveAttendanceComponent } from './drive-attendance.component';
import { DriveAttendanceRoutingModule } from './drive-attendance.routing.module';
import { CardModule } from 'primeng/card';
import { RadioButtonModule } from 'primeng/radiobutton';

@NgModule({
  imports: [
    CommonModule,
    DriveAttendanceRoutingModule,
    TableComponentModule,
    ProgressSpinnerModule,
    DividerModule,
    SidebarModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    CheckboxModule,
    CardModule,
    RadioButtonModule
  ],
  declarations: [DriveAttendanceComponent],
  exports: [DriveAttendanceComponent]
})
export class DriveAttendanceModule { }
